import ArrowRightAltIcon from '@mui/icons-material/ArrowRightAlt';
import { Alert, DialogActions, DialogContentText, DialogTitle, FormHelperText } from '@mui/material';
import Button from '@mui/material/Button';
import DialogContent from '@mui/material/DialogContent';
import FormControl from '@mui/material/FormControl';
import FormControlLabel from '@mui/material/FormControlLabel';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import * as React from 'react';
import { memo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AppState, store, useAppSelector } from 'src/store';
import { setSnackbarMessage } from 'src/store/snackbarMessage';
import DocManagementService from './service/DocManagementService';
import { setDocumentDetail } from 'src/store/documentDetail';

export interface ISubArtifactData {
  id: string;
  version: string;
}

const SelectSubartifact = (props: any) => {
  const { setOpenSubArtifact, versionNumber, checked, metaData, setDisablePHI } = props;
  const subArtifactVersions = props.subArtifactVersions;
  const [subArtifactVersionValue, setSubArtifactVersionValue] = useState<ISubArtifactData>({ id: '', version: '' });
  const docService = new DocManagementService();
  const user: any = useAppSelector(state => state.user.user);
  const userName = `${user.firstName + ' ' + user.lastName}`;
  const SearchHierarchyDetail: any = useSelector((state: AppState) => state.searchHierarchyDetails);
  const documentDetail: any = useSelector((state: AppState) => state.documentDetail);
  const dispatch = useDispatch();
  const [disableSave, setDisableSave] = useState(false);

  const updatedVersionData = async (docData: any) => {
    const res = await docService.updatedVersionData(
      docData,
      process.env.REACT_APP_NAME,
      'DocumentDetails',
      metaData.isf_document_name
    );
    if (res.data) {
      setDocumentDetail(dispatch, [
        {
          ...documentDetail.data[0],
          isf_doc_version_number: docData.isf_doc_new_version_number,
          isf_doc_status: res.data.document_data.isf_doc_status,
          isBtnDisabled: false
        }
      ]);
      store.dispatch(setSnackbarMessage('Document is updated successfully.', 'success'));
    } else {
      store.dispatch(setSnackbarMessage('Error in updating document.', 'error'));
    }
    handleClose();
  };

  const overwriteVersionData = async (overwriteDocData: any) => {
    const res = await docService.updateMasterDocument(
      overwriteDocData,
      process.env.REACT_APP_NAME,
      'DocumentDetails',
      metaData.isf_document_name,
      false
    );
    if (res.data) {
      setDocumentDetail(dispatch, [
        {
          ...documentDetail.data[0],
          isf_doc_status: res.data.document_data.isf_doc_status,
          isBtnDisabled: false
        }
      ]);
      store.dispatch(setSnackbarMessage('Document is updated successfully.', 'success'));
    } else {
      store.dispatch(setSnackbarMessage('Error in updating document.', 'error'));
    }
    handleClose();
  };

  const handleSaveUpdatedSubArtifact = async () => {
    setDisableSave(true);
    if (subArtifactVersionValue.id !== '') {
      const filterSubartifactId: any = subArtifactVersions.filter(
        (sub: any) => sub.isf_document_id === subArtifactVersionValue.id
      );
      const docDetails: any = await docService.getMasterDocumentdetails(
        filterSubartifactId[0]?.isf_doc_study,
        subArtifactVersionValue?.id,
        filterSubartifactId[0]?.isf_doc_version_number,
        filterSubartifactId[0]?.isf_doc_country,
        filterSubartifactId[0]?.isf_doc_site,
        filterSubartifactId[0]?.isf_doc_level,
        process.env.REACT_APP_NAME,
        'DocumentDetails',
        filterSubartifactId[0]?.isf_document_name
      );
      const docStatus =
        docDetails.data.document_data.isf_doc_status === 'Approved'
          ? 'Uploaded'
          : docDetails.data.document_data.isf_doc_status;

      const subartifactUpdateObj = {
        file_master_id: props.editedFmID ? props.editedFmID : props.resData.id,
        document_data: {
          isf_artifact_number: docDetails.data.document_data.isf_artifact_number,
          isf_document_name: props.docViewer
            ? docDetails.data.document_data.isf_document_name
            : props.metaData.isf_document_name,
          isf_doc_type: docDetails.data.document_data.isf_doc_type,
          isf_doc_subtype: docDetails.data.document_data.isf_doc_subtype,
          isf_doc_viewer_includes_phi: checked,
          isf_doc_viewer_red_certified_copy: metaData.isf_doc_viewer_red_certified_copy
            ? metaData.isf_doc_viewer_red_certified_copy
            : 'N',
          isf_doc_status: docStatus,
          isf_doc_country: docDetails.data.document_data.isf_doc_country,
          isf_doc_study: docDetails.data.document_data.isf_doc_study,
          isf_doc_site: docDetails.data.document_data.isf_doc_site,
          isf_doc_viewer_department: docDetails.data.document_data.isf_doc_viewer_department,
          isf_doc_viewer_language: docDetails.data.document_data.isf_doc_viewer_language,
          isf_doc_viewer_approval_cycle: docDetails.data.document_data.isf_doc_viewer_approval_cycle,
          isf_doc_viewer_product_detail: docDetails.data.document_data.isf_doc_viewer_product_detail,
          isf_doc_viewer_ref_model_version: docDetails.data.document_data.isf_doc_viewer_ref_model_version,
          isf_doc_viewer_format: docDetails.data.document_data.isf_doc_viewer_format,
          isf_doc_viewer_inspection_ready: docDetails.data.document_data.isf_doc_viewer_inspection_ready,
          isf_doc_viewer_ir_issue_type: docDetails.data.document_data.isf_doc_viewer_ir_issue_type,
          isf_doc_level: docDetails.data.document_data.isf_doc_level,
          isf_artifact_name: docDetails.data.document_data.isf_artifact_name,
          isf_doc_version_number: subArtifactVersionValue.version,
          isf_doc_milestone: docDetails.data.document_data.isf_doc_milestone,
          isf_document_id: subArtifactVersionValue.id,
          isf_doc_viewer_doc_phi_redacted: metaData.isf_doc_viewer_doc_phi_redacted
            ? metaData.isf_doc_viewer_doc_phi_redacted
            : 'N',
          id: docDetails.data.document_data.id,
          isf_doc_viewer_last_modified_by: userName
        }
      };
      versionNumber === 'Major' || versionNumber === 'Minor'
        ? updatedVersionData({ ...subartifactUpdateObj, isf_doc_new_version_number: subArtifactVersionValue.version })
        : overwriteVersionData(subartifactUpdateObj);
      props.handleCloseVersion();
      props.documentValue(
        SearchHierarchyDetail?.data[0]?.Study,
        SearchHierarchyDetail?.data[0]?.Country,
        SearchHierarchyDetail?.data[0]?.Site
      );
      props.setStyleUpload('uploadFile');
      props.setFileUploaded(null);
      props.setUploaded(false);
      setDisablePHI(false);
      props.ClearData();
    }
  };

  const handleBackDialogSubArtifact = () => {
    setOpenSubArtifact(false);
  };

  const handleCloseDialogSubArtifact = () => {
    setOpenSubArtifact(false);
    props.handleCloseVersion();
    props.documentValue(
      SearchHierarchyDetail?.data[0]?.Study,
      SearchHierarchyDetail?.data[0]?.Country,
      SearchHierarchyDetail?.data[0]?.Site
    );
    props.setStyleUpload('uploadFile');
    props.setFileUploaded(null);
    props.setUploaded(false);
    props.ClearData();
  };

  const dailogTitle = (versionNumber: string) => {
    if (versionNumber === 'Major') {
      return ' Select Subartifact to Update as Major Change';
    }
    if (versionNumber === 'Minor') {
      return ' Select Subartifact to Update as Minor Change';
    }
    if (versionNumber === 'Overwrite') {
      return ' Select Subartifact to Overwrite';
    }
  };

  const handleRadioValue = (e: any, value: any) => {
    setSubArtifactVersionValue({ id: value, version: e.target.name });
  };

  const handleClose = () => {
    props.setOpenVersion(false);
  };
  return (
    <div className="versionControl-modal">
      <React.Fragment>
        <DialogTitle>{dailogTitle(versionNumber)}</DialogTitle>
        <DialogContent className="selectSubArtifact-modalcontent">
          {versionNumber === 'Overwrite' && (
            <Alert severity="info">Overwriting will replace the current document</Alert>
          )}
          <DialogContentText>
            <dl>
              <dt>Artifact:</dt>
              <dd>{subArtifactVersions[0].isf_artifact_name}</dd>
            </dl>
            <dl>
              <dt>Subartifacts Uploaded:</dt>
            </dl>
          </DialogContentText>
          <FormControl className="special-radiobtn-group">
            <RadioGroup
              aria-labelledby="demo-radio-buttons-group-label"
              defaultValue={subArtifactVersionValue.id}
              name="radio-buttons-group"
              onChange={handleRadioValue}
            >
              {subArtifactVersions.map((el: any) => {
                if (versionNumber === 'Major' || versionNumber === 'Minor') {
                  return (
                    <div key={el.isf_document_id}>
                      <FormControlLabel
                        value={el.isf_document_id}
                        control={<Radio />}
                        label={el.isf_document_name}
                        name={
                          versionNumber === 'Major'
                            ? Math.floor(el.isf_doc_version_number + 1.0).toFixed(1)
                            : (el.isf_doc_version_number + 0.1).toFixed(1)
                        }
                        labelPlacement="start"
                        sx={{
                          '& .MuiSvgIcon-root': {
                            fontSize: 24
                          }
                        }}
                        disabled={disableSave}
                      />
                      <FormHelperText>
                        Current:&nbsp;<span>Version {el.isf_doc_version_number.toFixed(1)}</span> <ArrowRightAltIcon />{' '}
                        After Update:{' '}
                        <span>
                          &nbsp;
                          {versionNumber === 'Major'
                            ? Math.floor(el.isf_doc_version_number + 1.0).toFixed(1)
                            : (el.isf_doc_version_number + 0.1).toFixed(1)}
                        </span>
                      </FormHelperText>
                    </div>
                  );
                } else {
                  return (
                    <div key={el.isf_document_id}>
                      <FormControlLabel
                        value={el.isf_document_id}
                        control={<Radio />}
                        label={el.isf_document_name}
                        name={el.isf_doc_version_number.toFixed(1)}
                        labelPlacement="start"
                        sx={{
                          '& .MuiSvgIcon-root': {
                            fontSize: 24
                          }
                        }}
                        disabled={disableSave}
                      />
                      <FormHelperText>
                        Overwrite current version: &nbsp; <span> {el.isf_doc_version_number.toFixed(1)}</span>
                      </FormHelperText>
                    </div>
                  );
                }
              })}
            </RadioGroup>
          </FormControl>
        </DialogContent>
        <DialogActions sx={{ justifyContent: 'space-between' }}>
          <div>
            <Button onClick={handleBackDialogSubArtifact} className="grey-btn" disabled={disableSave}>
              Back
            </Button>
          </div>
          <div>
            <Button onClick={handleCloseDialogSubArtifact} className="grey-btn" disabled={disableSave}>
              Close
            </Button>
            <Button onClick={handleSaveUpdatedSubArtifact} disabled={disableSave || !subArtifactVersionValue?.id}>
              Save
            </Button>
          </div>
        </DialogActions>
      </React.Fragment>
    </div>
  );
};

export default memo(SelectSubartifact);
